"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = configure;

var _axios = _interopRequireDefault(require("axios"));

var _AxiosAdapter = _interopRequireDefault(require("./AxiosAdapter"));

var _LocalConfigService = _interopRequireDefault(require("./LocalConfigService"));

var _LocalTokenStore = _interopRequireDefault(require("./LocalTokenStore"));

function configure(coreInstance, _ref) {
  var config = _ref.config,
      axios = _ref.axios,
      requestAdapter = _ref.requestAdapter,
      tokenStore = _ref.tokenStore,
      configService = _ref.configService;
  coreInstance.register('config', configService || new _LocalConfigService["default"](config));
  coreInstance.api.tokens.tokenStore = tokenStore || new _LocalTokenStore["default"]();
  coreInstance.requestAdapter = requestAdapter || new _AxiosAdapter["default"](axios || _axios["default"]);
}